// extracted by mini-css-extract-plugin
module.exports = {"tree":"JGtWH0_IavtHbZX3xopJy","setPrimary":"_1IBSvjdHCAG0eVKd97jCdW","item":"_2nY1HBjLgS260Ef5n5BTYJ"};